<spe-alert [class]="apiStatus" [message]="message"></spe-alert>
<spe-titulo-sessao [titulo]="reportName!" icone="assets/icones/cinza/documentos.svg"></spe-titulo-sessao>

<div class="overflow-x-auto rounded-16">
  <table mat-table matSort spe-table [dataSource]="dataSource">
    <ng-container matColumnDef="dataInicioExecucao">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Data Solicitação</th>
      <td mat-cell *matCellDef="let element">{{ element.dataInicioExecucao }}</td>
    </ng-container>

    <ng-container matColumnDef="dataFimExecucao">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Finalizado em</th>
      <td mat-cell *matCellDef="let element">{{ element.dataFimExecucao }}</td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
      <td mat-cell *matCellDef="let element">
        <span class="status-chip" [ngClass]="getStatusColorClass(element.status)">{{ getStatus(element) }}</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="download">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element" class="text-end">
        <button
          class="color-brand-principal"
          *ngIf="element.status === 'Finalizado'"
          mat-icon-button
          (click)="clickHere(element)"
          matTooltip="Fazer download"
          matTooltipPosition="above"
        >
          <mat-icon svgIcon="download-current" />
        </button>
        <div *ngIf="element.status === 'Erro'">-</div>
        <div *ngIf="element.status != 'Erro' && element.status != 'Finalizado'">Processando</div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    <!-- Row para quando nao encontra resultado da busca -->
    <tr class="background" *matNoDataRow>
      <td class="pt-24 pb-24" colspan="15">Nenhum relatório solicitado</td>
    </tr>
  </table>
</div>
